var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "bvid-convert" }, [
    _vm.aid
      ? _c("div", { staticClass: "bvid-convert-item" }, [
          _vm._v("\n    " + _vm._s(_vm.aid) + "\n    "),
          _c(
            "div",
            {
              staticClass: "bvid-convert-item-copy",
              attrs: { title: "复制链接" },
              on: {
                click: function ($event) {
                  return _vm.copyLink("aid")
                },
              },
            },
            [
              _c("VIcon", {
                attrs: {
                  size: 16,
                  icon: _vm.aidCopied ? "mdi-check" : "mdi-link",
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.bvid
      ? _c("div", { staticClass: "bvid-convert-item" }, [
          _vm._v("\n    " + _vm._s(_vm.bvid) + "\n    "),
          _c(
            "div",
            {
              staticClass: "bvid-convert-item-copy",
              attrs: { title: "复制链接" },
              on: {
                click: function ($event) {
                  return _vm.copyLink("bvid")
                },
              },
            },
            [
              _c("VIcon", {
                attrs: {
                  size: 16,
                  icon: _vm.bvidCopied ? "mdi-check" : "mdi-link",
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }